var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowSvg1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 48,
    height: 48,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M39.21 39.7101L34.0186 34.5186M36.1068 29.3622C36.1068 33.3614 32.8649 36.6033 28.8659 36.6033C24.8669 36.6033 21.625 33.3614 21.625 29.3622C21.625 25.363 24.8669 22.1211 28.8659 22.1211C32.8649 22.1211 36.1068 25.363 36.1068 29.3622Z",
    stroke: "#4D4E99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5541 35.5676H15.4165C14.8678 35.5676 14.3416 35.3497 13.9536 34.9617C13.5656 34.5737 13.3477 34.0474 13.3477 33.4987V23.1543",
    stroke: "#4D4E99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21094 21.0859L22.6583 9.70703L36.1057 21.0859",
    stroke: "#4D4E99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M29.8984 10.7422H34.0361V14.88",
    stroke: "#4D4E99",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowSvg1);
export default __webpack_public_path__ + "static/media/howSVG1.7f97c1f1b141b4cd50b779ca809e3579.svg";
export { ForwardRef as ReactComponent };